import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<Router>
		<App
			login={
				"https://raw.githubusercontent.com/ChiemezieSamson/world-countries-api/master/world-countries-api.json?token=GHSAT0AAAAAABWGTFRVAK2WQE4TFSYA5GMCYWREOVQ"
			}
		/>
	</Router>
);
